const site = {
  siteMetadata: {
    // siteUrl: "http://localhost:8000",
    siteUrl: "https://freelancology.netlify.app",
  },
}

export default site
